// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== RECORDINGS PAGE – Figma-aligned dark theme ===== */

.recordings-page {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
  overflow: hidden;
  position: relative;
  /* Paleta XTAM (Analytics / Inventario): fondos #0a0a0a–#111, bordes #374151, acento #a61b34 */
  --rx-toolbar: #0a0a0a;
  --rx-surface: #111111;
  --rx-surface-2: #1a1a1a;
  --rx-slot: #0a0a0a;
  --rx-border: #374151;
  --rx-accent: #a61b34;
  --rx-accent-deep: #8b1528;
}

.recordings-page.loading-state {
  align-items: center;
  justify-content: center;
}

.recordings-page.loading-state .xtam-spinner--inline {
  min-height: min(320px, 60vh);
  padding: 40px 20px;
}

/* Misma lógica que .streams-shell: con el listado de cámaras abierto, la grilla no queda debajo del panel */
.recordings-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  background: #000;
  transition: width 0.25s ease;
  box-sizing: border-box;
}

.recordings-shell.schema-sidebar-open {
  width: calc(100% - 320px);
  max-width: 100%;
}

/* ── Header / Toolbar ── */
.recordings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: var(--rx-toolbar);
  border-bottom: 1px solid #1f2937;
  gap: 8px;
  min-height: 49px;
  flex-shrink: 0;
  z-index: 40;
}

.recordings-header-right {
  flex: 1 1;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.recordings-spoa-header-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 8px;
  cursor: pointer;
}

.recordings-spoa-header-btn:hover:not(:disabled) {
  border-color: #a61b34;
  background: rgba(166, 27, 52, 0.15);
}

.recordings-spoa-header-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.recordings-spoa-header-badge {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  background: #a61b34;
  color: #fff;
}

.grid-controls .grid-clear-grid-btn {
  margin-left: 6px;
}

.grid-btn:disabled,
.grid-btn:disabled:hover {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--rx-surface);
  border-color: var(--rx-border);
  color: #9ca3af;
}

/* ── Panel colapsable "Cámaras disponibles" (estilo /streams) ── */
.recordings-schema-sidebar {
  --schema-width: 320px;
  --schema-pvvc: #3b82f6;
  --schema-privados: #f97316;
  --schema-eu: #E07054;
  --schema-masivos: #14b8a6;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: var(--schema-width);
  min-width: 0;
  min-height: 0;
  background: linear-gradient(195deg, #1c1c1c 0%, #121212 45%, #0e0e0e 100%);
  border-left: 1px solid #333333;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  transform: translateX(100%);
  transition: transform 0.25s ease;
}
.recordings-schema-sidebar.open { transform: translateX(0); }
.recordings-schema-sidebar.collapsed { transform: translateX(100%); }

.recordings-schema-backdrop {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 9999;
  pointer-events: none;
}
.recordings-schema-backdrop.recordings-schema-backdrop-drag-passthrough { pointer-events: none; }
/* Permitir drop sobre la grilla aunque el backdrop esté encima: se aplica en el mismo tick que dragStart */
body[data-dragging-from-schema] .recordings-schema-backdrop { pointer-events: none; }

.recordings-schema-header {
  padding: 14px 12px 12px;
  border-bottom: 1px solid #333333;
  background: #0e0e0e;
}
.recordings-schema-title { display: flex; align-items: center; gap: 10px; }
.recordings-schema-title-icon { color: #9ca3af; flex-shrink: 0; }
.recordings-schema-title-text { font-size: 15px; font-weight: 700; color: #fff; }
.recordings-schema-search-wrap { position: relative; margin-top: 10px; }
.recordings-schema-search-icon {
  position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
  color: #6b7280; pointer-events: none;
}
.recordings-schema-search {
  width: 100%; box-sizing: border-box; padding: 9px 12px 9px 34px;
  border: 1px solid #3d3d3d; border-radius: 8px; background: #1a1a1a;
  color: #e5e7eb; font-size: 13px; outline: none;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.recordings-schema-search::placeholder { color: #6b7280; }
.recordings-schema-search:focus { border-color: #a61b34; background: #252525; }

.recordings-schema-body {
  flex: 1 1; min-height: 0; overflow: auto; padding: 10px; background: transparent;
}
.recordings-schema-toggle {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 56px;
  border-radius: 10px 0 0 10px;
  /* Portal a body: no hereda --rx-* de .recordings-page */
  border: 4px solid #a61b34;
  border-right: none;
  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);
  color: #fecaca;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  transition: right 0.25s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  right: 0;
}
.recordings-schema-toggle.open { right: 320px; }
.recordings-schema-toggle:hover {
  background: linear-gradient(135deg, #c42a45 0%, #a61b34 100%);
  border-color: #c42a45;
  color: #fff;
}

.recordings-schema-section { margin-bottom: 14px; }
.recordings-schema-section-header {
  width: 100%; border: none; border-radius: 10px; padding: 10px 12px; color: #fff;
  display: flex; align-items: center; gap: 8px; cursor: pointer; font: inherit; text-align: left;
  transition: background 0.15s ease;
}
.recordings-schema-section-pvvc .recordings-schema-section-header {
  background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.3);
}
.recordings-schema-section-privados .recordings-schema-section-header {
  background: rgba(249, 115, 22, 0.15); border: 1px solid rgba(249, 115, 22, 0.3);
}
.recordings-schema-section-eu .recordings-schema-section-header {
  background: rgba(224, 112, 84, 0.15); border: 1px solid rgba(224, 112, 84, 0.3);
}
.recordings-schema-section-masivos .recordings-schema-section-header {
  background: rgba(20, 184, 166, 0.15); border: 1px solid rgba(20, 184, 166, 0.35);
}
.recordings-schema-section-header:hover { filter: brightness(1.1); }
.recordings-schema-section-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.recordings-schema-section-pvvc .recordings-schema-section-dot { background: var(--schema-pvvc); }
.recordings-schema-section-privados .recordings-schema-section-dot { background: var(--schema-privados); }
.recordings-schema-section-eu .recordings-schema-section-dot { background: var(--schema-eu); }
.recordings-schema-section-masivos .recordings-schema-section-dot { background: var(--schema-masivos); }
.recordings-schema-section-name { font-weight: 700; font-size: 13px; flex: 1 1; }
.recordings-schema-section-count {
  font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: 6px;
  color: #fff; min-width: 28px; text-align: center;
}
.recordings-schema-section-pvvc .recordings-schema-section-count { background: var(--schema-pvvc); }
.recordings-schema-section-privados .recordings-schema-section-count { background: var(--schema-privados); }
.recordings-schema-section-eu .recordings-schema-section-count { background: var(--schema-eu); }
.recordings-schema-section-masivos .recordings-schema-section-count { background: var(--schema-masivos); }
.recordings-schema-section-content { margin-top: 8px; padding-left: 4px; }
.recordings-schema-chevron { transition: transform 0.15s ease; color: #9ca3af; flex-shrink: 0; }
.recordings-schema-chevron.open { transform: rotate(180deg); }
.recordings-schema-grip { color: #6b7280; flex-shrink: 0; cursor: grab; }
.recordings-schema-site { margin-bottom: 6px; }
.recordings-schema-site-header {
  width: 100%; background: #1a1a1a; border: 1px solid #3d3d3d; color: #e5e7eb;
  border-radius: 8px; padding: 8px 10px; display: flex; align-items: center; gap: 8px;
  cursor: pointer; font: inherit; text-align: left; transition: border-color 0.15s, background 0.15s;
  border-left: 3px solid #6b7280;
}
.recordings-schema-site-header--online { border-left-color: #10B981; }
.recordings-schema-site-header--partial { border-left-color: #F59E0B; }
.recordings-schema-site-header--offline { border-left-color: #EF4444; }
.recordings-schema-site-header--unknown { border-left-color: #6b7280; }
.recordings-schema-section-pvvc .recordings-schema-site-header {
  background: rgba(59, 130, 246, 0.06);
}
.recordings-schema-section-privados .recordings-schema-site-header {
  background: rgba(249, 115, 22, 0.06);
}
.recordings-schema-section-eu .recordings-schema-site-header {
  background: rgba(224, 112, 84, 0.06);
}
.recordings-schema-section-masivos .recordings-schema-site-header {
  border-left-color: var(--schema-masivos); background: rgba(20, 184, 166, 0.06);
}
.recordings-schema-site-header:hover { background: #252525; border-color: #4b5563; }
.recordings-schema-section-pvvc .recordings-schema-site-header:hover {
  background: rgba(59, 130, 246, 0.12);
}
.recordings-schema-section-privados .recordings-schema-site-header:hover {
  background: rgba(249, 115, 22, 0.12);
}
.recordings-schema-section-eu .recordings-schema-site-header:hover {
  background: rgba(224, 112, 84, 0.12);
}
.recordings-schema-section-masivos .recordings-schema-site-header:hover {
  border-left-color: var(--schema-masivos); background: rgba(20, 184, 166, 0.12);
}
.recordings-schema-site-header--online:hover { border-left-color: #10B981; }
.recordings-schema-site-header--partial:hover { border-left-color: #F59E0B; }
.recordings-schema-site-header--offline:hover { border-left-color: #EF4444; }
.recordings-schema-site-header--unknown:hover { border-left-color: #6b7280; }
.recordings-schema-site-header-draggable { cursor: grab; }
.recordings-schema-site-header-draggable:active { cursor: grabbing; }
.recordings-schema-site-name {
  font-size: 12px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1 1; min-width: 0;
}
.recordings-schema-section-pvvc .recordings-schema-site-name { color: var(--schema-pvvc); }
.recordings-schema-section-privados .recordings-schema-site-name { color: var(--schema-privados); }
.recordings-schema-section-eu .recordings-schema-site-name { color: var(--schema-eu); }
.recordings-schema-section-masivos .recordings-schema-site-name { color: var(--schema-masivos); }
.recordings-schema-site-cam-count { font-size: 11px; font-weight: 600; flex-shrink: 0; }
.recordings-schema-section-pvvc .recordings-schema-site-cam-count { color: var(--schema-pvvc); }
.recordings-schema-section-privados .recordings-schema-site-cam-count { color: var(--schema-privados); }
.recordings-schema-section-eu .recordings-schema-site-cam-count { color: var(--schema-eu); }
.recordings-schema-section-masivos .recordings-schema-site-cam-count { color: var(--schema-masivos); }
.recordings-schema-site-cam-total { color: #6b7280; font-weight: 400; }
.recordings-schema-cameras { margin-top: 6px; padding-left: 8px; display: flex; flex-direction: column; gap: 4px; }
.recordings-schema-camera {
  display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px;
  background: #1a1a1a; border: 1px solid #3d3d3d; cursor: grab; transition: border-color 0.15s, background 0.15s;
}
.recordings-schema-camera:hover { border-color: #4b5563; background: #252525; }
.recordings-schema-camera:active { cursor: grabbing; }
.recordings-schema-camera-status {
  width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.35);
}
.recordings-schema-camera-status--on { background: #22c55e; }
.recordings-schema-camera-status--off { background: #dc2626; }
.recordings-schema-camera-status--issue { background: #f97316; }
.recordings-schema-camera-status--unknown { background: #6b7280; }
.recordings-schema-camera--off { opacity: 0.72; }
.recordings-schema-camera--off .recordings-schema-camera-name { color: #d1d5db; }
.recordings-schema-camera--issue .recordings-schema-camera-name { color: #fdba74; }
.recordings-schema-camera-warn { color: #f87171; flex-shrink: 0; }
.recordings-schema-camera-info { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.recordings-schema-camera-name { font-size: 12px; font-weight: 600; color: #fff; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.recordings-schema-camera-address { font-size: 11px; color: #9ca3af; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.recordings-schema-camera-badge { font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 4px; flex-shrink: 0; color: #fff; }
.recordings-schema-section-pvvc .recordings-schema-camera-badge { background: var(--schema-pvvc); }
.recordings-schema-section-privados .recordings-schema-camera-badge { background: var(--schema-privados); }
.recordings-schema-section-eu .recordings-schema-camera-badge { background: var(--schema-eu); }
.recordings-schema-section-masivos .recordings-schema-camera-badge { background: var(--schema-masivos); }
.recordings-schema-empty { color: #9ca3af; font-size: 12px; padding: 8px 10px; }
.recordings-schema-hint { margin-top: 10px; font-size: 12px; color: #9ca3af; padding: 10px; border-radius: 8px; border: 1px dashed #3d3d3d; background: rgba(255,255,255,0.03); }
.recordings-schema-no-results { color: #6b7280; font-style: italic; }

.header-left {
  flex: 0 0 280px;
}

.search-box {
  display: flex;
  align-items: center;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 8px;
  padding: 7px 12px;
  gap: 8px;
  transition: border-color 0.2s;
}

.search-box:hover {
  border-color: #4b5563;
}

.search-box:focus-within {
  border-color: var(--rx-accent);
}

.search-icon {
  width: 16px;
  height: 16px;
  color: #6b7280;
  flex-shrink: 0;
}

.search-box input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 12px;
  outline: none;
}

.search-box input::placeholder {
  color: #6b7280;
}

.header-center {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cameras-label {
  display: none; /* hidden in Figma design */
}

/* PVVC / Privado toggle switch – matches search box width */
.tabs {
  display: flex;
  flex: 0 0 280px;
  box-sizing: border-box;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 4px;
  overflow: hidden;
  padding: 1px;
}

.tab {
  flex: 1 1;
  padding: 3px 14px;
  background: transparent;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  line-height: 1.4;
  text-align: center;
}

/* PVVC inactive = blue text */
.tab:first-child {
  color: #60a5fa;
}

.tab:first-child:hover:not(.active) {
  background: rgba(59, 130, 246, 0.15);
}

/* PVVC active = solid blue bg */
.tab:first-child.active {
  background: #3b82f6;
  color: #fff;
}

/* Privado inactive = orange text */
.tab:last-child {
  color: #fb923c;
}

.tab:last-child:hover:not(.active) {
  background: rgba(249, 115, 22, 0.15);
}

/* Privado active = solid orange bg */
.tab:last-child.active {
  background: #f97316;
  color: #fff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-left-vista {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.btn-toggle-cameras {
  display: none; /* panel is controlled by tab toggle in new design */
}

.view-label {
  color: #9ca3af;
  font-size: 14px;
  margin-right: 4px;
}

.grid-controls {
  display: flex;
  gap: 4px;
}

.grid-btn {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.grid-btn:hover {
  background: var(--rx-surface);
  color: #d1d5db;
}

.grid-btn.active {
  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);
  border-color: var(--rx-accent);
  color: #fff;
}

.grid-btn.highlight.active {
  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);
  color: #fff;
}

.grid-btn svg {
  width: 22px;
  height: 22px;
}

/* ── Camera Cards Panel (horizontal accordion, in document flow) ── */
.camera-cards-panel {
  max-height: 135px;
  background: rgba(0, 0, 0, 0.98);
  backdrop-filter: blur(8px);
  border-bottom: 2px solid #3b82f6;
  overflow: hidden;
  flex-shrink: 0;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, border-color 0.3s;
  opacity: 1;
}

.camera-cards-panel.panel-hidden {
  max-height: 0;
  opacity: 0;
  pointer-events: none;
  border-bottom-width: 0;
}

.camera-cards-panel.privado-panel {
  border-bottom-color: #f97316;
}

.camera-cards-scroll {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-auto-flow: column;
  grid-auto-columns: 252px;
  gap: 10px;
  padding: 6px 8px;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.camera-cards-scroll::-webkit-scrollbar {
  display: none;
}

.no-cameras-message {
  color: #6b7280;
  font-size: 13px;
  padding: 20px;
  text-align: center;
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Camera Card (in panel) */
.camera-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, var(--rx-surface-2) 0%, var(--rx-surface) 100%);
  border: 1px solid var(--rx-border);
  border-radius: 8px;
  cursor: grab;
  transition: all 0.2s;
  flex-shrink: 0;
  height: 100%;
}

.camera-card:hover {
  background: linear-gradient(135deg, #252525 0%, var(--rx-surface-2) 100%);
  border-color: #4b5563;
}

.camera-card:active {
  cursor: grabbing;
}

.camera-card.dragging {
  opacity: 0.5;
  transform: scale(0.98);
}

.camera-card.in-use {
  opacity: 0.4;
  cursor: not-allowed;
}

.camera-card.in-use:hover {
  background: linear-gradient(135deg, var(--rx-surface-2) 0%, var(--rx-surface) 100%);
}

.card-drag-handle {
  width: 14px;
  height: 20px;
  color: #6b7280;
  flex-shrink: 0;
}

.card-drag-handle svg {
  width: 100%;
  height: 100%;
}

.card-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.card-site-name {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-address {
  font-size: 10px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-camera-name {
  font-size: 10px;
  color: #d1d5db;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
}

.card-type-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  flex-shrink: 0;
}

.card-type-badge.pvvc {
  background: #3b82f6;
  color: #fff;
}

.card-type-badge.privado {
  background: #f97316;
  color: #fff;
}

/* ── Video Grid ──
   La grilla ocupa el flex restante bajo el header; 1×1 / 1×2 / 2×2 usan filas 1fr para que los slots
   llenen el alto (el vídeo mantiene proporción con object-fit dentro del reproductor).
   El contenedor es CSS Grid (1 fila 1fr), no flex-column: así el hijo .video-grid recibe altura de pista
   definida y no colapsa la fila 1fr interna (evita una sola celda “en banda” con hueco negro debajo). */
.video-grid-container {
  flex: 1 1;
  min-height: 0;
  max-height: 100%;
  padding: 10px;
  /* Sin scroll: el grid ajusta sus pistas a la altura disponible y los slots se achican. */
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  box-sizing: border-box;
}

.video-grid {
  display: grid;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  max-height: 100%;
  height: 100%;
  box-sizing: border-box;
  align-self: stretch;
  justify-self: stretch;
}

.video-grid.grid-1x1 {
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  justify-items: stretch;
  align-content: stretch;
}

.video-grid.grid-1x2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: minmax(0, 1fr);
  align-content: stretch;
}

.video-grid.grid-2x2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  align-content: stretch;
}

/* ── Video Slot ── */
.video-slot {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  /* El alto viene de la pista del grid (1fr). Evitamos aspect-ratio / max-height fijos para que
     al cambiar el tamaño del viewport los slots se encojan y quepan sin generar scroll. */
  height: 100%;
  align-self: stretch;
  background: var(--rx-slot);
  border: 2px dashed var(--rx-border);
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;
}

.video-slot.empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-slot.empty:hover,
.video-slot.drop-target.empty {
  border-color: var(--rx-accent);
  background: rgba(166, 27, 52, 0.08);
}

.video-slot.has-camera {
  border-style: solid;
  border-color: transparent;
  border-width: 0;
  background: var(--rx-slot);
}

/* Un solo borde: el marco es el .video-slot; la drop zone anidada no repite borde */
.video-slot .camera-drop-zone {
  border: none;
}

.video-slot .recording-card.recording-card-slot {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* El relleno del slot (drop zone / video) debe ocupar toda la altura de la celda */
.video-slot .recording-card.recording-card-slot > .camera-drop-zone {
  flex: 1 1;
  min-height: 0;
  width: 100%;
}

.video-slot-expanded-placeholder {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--rx-slot);
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
}

.video-slot-expanded-placeholder:hover {
  background: var(--rx-surface);
  color: #d1d5db;
}

.video-slot-expanded-placeholder .placeholder-hint {
  font-size: 11px;
  color: #4b5563;
}

.empty-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #4b5563;
  text-align: center;
  padding: 20px;
}

.slot-icon {
  width: 32px;
  height: 32px;
  color: #374151;
}

.slot-icon svg {
  width: 100%;
  height: 100%;
}

.slot-text {
  font-size: 12px;
  color: #6b7280;
}

.slot-number {
  font-size: 10px;
  color: #4b5563;
}

/* ── Video Content (camera in slot) ── */
.video-content {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--rx-slot);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.video-content .video-stream {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  height: 100%;
}

/* Camera info overlay at top center */
.video-info-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 8px 12px;
  z-index: 5;
  pointer-events: none;
}

.camera-info-overlay {
  background: rgba(0, 0, 0, 0.7);
  padding: 4px 12px;
  border-radius: 6px;
  text-align: center;
  max-width: 80%;
}

.overlay-site {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overlay-name {
  font-size: 10px;
  color: #d1d5db;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Type badge at bottom-left */
.overlay-badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  z-index: 5;
}

.overlay-badge.pvvc {
  background: #3b82f6;
  color: #fff;
}

.overlay-badge.privado {
  background: #f97316;
  color: #fff;
}

/* REC indicator at bottom-right */
.rec-indicator {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);
  padding: 6px;
  border-radius: 4px;
  z-index: 5;
}

.rec-indicator svg {
  width: 18px;
  height: 18px;
  color: #fff;
  fill: currentColor;
  stroke: currentColor;
}

/* Drag handle at top-left */
.slot-drag-handle {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.7);
  padding: 4px 8px;
  border-radius: 4px;
  cursor: move;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s;
}

.video-slot:hover .slot-drag-handle {
  opacity: 1;
}

.slot-drag-handle svg {
  width: 16px;
  height: 16px;
  color: #fff;
}

/* Expand button (center, on hover) */
.expand-camera-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  background: rgba(166, 27, 52, 0.92);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.expand-camera-btn svg {
  width: 20px;
  height: 20px;
}

.video-slot:hover .expand-camera-btn {
  opacity: 0.4;
}

.video-slot:hover .expand-camera-btn:hover {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1.1);
}

/* Remove button (top-right, on hover) */
.remove-camera-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.video-slot:hover .remove-camera-btn {
  opacity: 1;
}

.remove-camera-btn:hover {
  background: linear-gradient(135deg, #c42a45 0%, var(--rx-accent) 100%);
}

/* ── Modal video ampliado ── */
.video-expand-overlay {
  position: fixed;
  inset: 0;
  /* Por encima del sidebar (1000) para que el modal no quede recortado */
  z-index: 1100;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: fadeIn 0.3s ease;
}

/*
 * Modal SIEMPRE montado para que \`expandedPlayerHost\` (destino del portal del \`<video>\`) sea estable:
 * teletransportar el \`<video>\` entre grid y modal sin desmontarlo es lo que preserva el buffer Hls.js
 * (segmentos m3u8/ts). Cuando no hay slot maximizado, se oculta el contenedor entero.
 */
.video-expand-overlay--hidden {
  display: none;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.video-expand-content {
  position: relative;
  width: 100%;
  max-width: 95vw;
  max-height: 90vh;
  background: var(--rx-surface);
  border: 1px solid var(--rx-border);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.video-expand-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  width: 40px;
  height: 40px;
  background: rgba(166, 27, 52, 0.92);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.video-expand-content:hover .video-expand-close {
  opacity: 0.4;
}

.video-expand-close:hover {
  opacity: 1 !important;
}

.video-expand-evidence {
  position: absolute;
  top: 12px;
  right: 56px;
  z-index: 10;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.video-expand-content:hover .video-expand-evidence {
  opacity: 0.55;
}

.video-expand-evidence:hover {
  opacity: 1 !important;
  border-color: #a61b34;
  background: rgba(166, 27, 52, 0.35);
}

.video-expand-evidence--captured {
  opacity: 1 !important;
  border-color: #22c55e !important;
  background: rgba(34, 197, 94, 0.4) !important;
  animation: rx-expand-evidence-pop 0.55s ease;
}

@keyframes rx-expand-evidence-pop {
  0% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}

.video-expand-player {
  position: relative;
  width: 100%;
  flex: 0 1 auto;
  min-height: 0;
  aspect-ratio: 16 / 9;
  /* Deja espacio para título + barra de reproducción (timeline, play/stop, fecha/hora) */
  max-height: min(56vw, calc(95vh - 280px));
  background: #000;
}

.video-expand-player .video-stream {
  width: 100%;
  height: 100%;
}

.video-expand-player .video-stream video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-expand-loading,
.video-expand-error {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  background: #0a0a0a;
  color: var(--rx-text, #e8e8e8);
}

.video-expand-error-text {
  margin: 0;
  text-align: center;
  font-size: 0.95rem;
  line-height: 1.4;
  max-width: 360px;
}

.video-expand-retry {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #a61b34 0%, var(--rx-accent, #c42a45) 100%);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

.video-expand-retry:hover {
  filter: brightness(1.08);
}

.video-expand-overlay-bottom {
  position: absolute;
  bottom: 14px;
  left: 34px;
  right: auto;
  width: max-content;
  max-width: calc(100% - 48px);
  z-index: 10;
  padding: 10px 14px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
  display: flex;
  align-items: center;
  gap: 10px;
  pointer-events: none;
}

.video-expand-status-pill,
.video-expand-time-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
}

.video-expand-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #9ca3af;
}

.video-expand-status-pill.playing .video-expand-status-dot {
  background: #22c55e;
}

.video-expand-status-pill.loading .video-expand-status-dot {
  background: #f59e0b;
}

.video-expand-status-pill.error .video-expand-status-dot,
.video-expand-status-pill.offline .video-expand-status-dot {
  background: #ef4444;
}

.video-expand-info {
  flex-shrink: 0;
  padding: 10px 16px;
  background: var(--rx-toolbar);
  border-top: 1px solid var(--rx-border);
  color: #9ca3af;
  font-size: 13px;
}

/* Controles de reproducción dentro del modal ampliado (misma barra que en vista normal) */
.video-expand-playback.playback-section {
  flex-shrink: 0;
  max-height: min(50vh, 420px);
  overflow-y: auto;
}

/* En pantallas estrechas, permitir que los controles envuelvan sin cortarse */
.video-expand-playback .playback-controls {
  flex-wrap: wrap;
  gap: 10px;
}

/* ── Fullscreen nativo (Fullscreen API) ── */

.video-expand-overlay:fullscreen::backdrop,
.video-expand-overlay:-webkit-full-screen::backdrop {
  background: #000;
}

.video-expand-overlay--fullscreen {
  background: #000;
  padding: 0;
}

.video-expand-overlay--fullscreen .video-expand-content {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: #000;
}

.video-expand-overlay--fullscreen .video-expand-player {
  flex: 1 1 auto;
  max-height: none;
  aspect-ratio: auto;
}

.video-expand-overlay--fullscreen .video-expand-player .video-stream video {
  object-fit: contain;
}

.video-expand-overlay--fullscreen .video-expand-info {
  background: rgba(0, 0, 0, 0.85);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
}

.video-expand-overlay--fullscreen .video-expand-playback.playback-section {
  background: rgba(0, 0, 0, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  max-height: none;
}

.video-expand-overlay--fullscreen .playback-controls {
  background: transparent;
}

.video-expand-overlay--fullscreen .video-expand-close {
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  font-size: 24px;
}

/* ── Playback Section ── */
.playback-section {
  background: var(--rx-toolbar);
  border-top: 1px solid #1f2937;
  flex-shrink: 0;
  padding: 12px;
}

.playback-section .playback-inner {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.playback-error-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: rgba(166, 27, 52, 0.15);
  border: 1px solid var(--rx-accent);
  border-radius: 8px;
  color: #fca5a5;
  font-size: 13px;
}

.playback-error-banner button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 18px;
  padding: 0 6px;
}

.recording-extend-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  padding: 10px 12px;
  margin-bottom: 8px;
  background: rgba(234, 179, 8, 0.12);
  border: 1px solid rgba(234, 179, 8, 0.45);
  border-radius: 8px;
  color: #fde68a;
  font-size: 13px;
}

.recording-extend-banner__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.recording-extend-banner .btn-extend-confirm {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  background: #ca8a04;
  color: #0a0a0a;
}

.recording-extend-banner .btn-extend-dismiss {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: transparent;
  color: #e5e7eb;
  cursor: pointer;
  font-size: 13px;
}

.playback-loading-banner {
  padding: 8px 12px;
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid #3b82f6;
  border-radius: 8px;
  color: #93c5fd;
  font-size: 13px;
}

/* Playback Controls */
.playback-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.controls-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--rx-surface);
  border: 1px solid var(--rx-border);
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.control-btn:hover {
  background: var(--rx-surface-2);
  border-color: #4b5563;
}

.control-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.control-btn.play-btn {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);
  border: none;
  border-radius: 50%;
}

.control-btn.play-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #c42a45 0%, var(--rx-accent) 100%);
}

.control-btn svg {
  width: 18px;
  height: 18px;
}

.time-display {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 6px;
  color: #fff;
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
  font-size: 13px;
}

.clock-icon {
  width: 16px;
  height: 16px;
  color: #6b7280;
}

.controls-center {
  display: flex;
  align-items: center;
}

.speed-controls {
  display: flex;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 6px;
  overflow: hidden;
}

.speed-btn {
  padding: 6px 12px;
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.speed-btn:hover {
  color: #fff;
  background: var(--rx-surface);
}

.speed-btn.active {
  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);
  color: #fff;
}

.controls-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.date-picker,
.time-picker {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 6px;
  position: relative;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.date-picker.date-picker--loading,
.time-picker.time-picker--loading {
  border-color: var(--rx-accent);
  box-shadow: 0 0 0 1px rgba(166, 27, 52, 0.35);
}

.date-picker-loader {
  color: var(--rx-accent);
  flex-shrink: 0;
  animation: rspoa-spin 0.9s linear infinite;
}

@keyframes rspoa-spin {
  to { transform: rotate(360deg); }
}

.calendar-icon {
  width: 18px;
  height: 18px;
  color: #6b7280;
}

.date-picker input,
.time-picker input.time-picker-native {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  font-variant-numeric: tabular-nums;
  color-scheme: dark;
  min-width: 5.5rem;
}

.date-picker input:disabled,
.time-picker input.time-picker-native:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  pointer-events: none;
}

.date-picker input::-webkit-calendar-picker-indicator,
.time-picker input.time-picker-native::-webkit-calendar-picker-indicator {
  filter: invert(0.7);
  cursor: pointer;
  opacity: 1;
}

.btn-use-now {
  padding: 6px 12px;
  background: var(--rx-toolbar);
  border: 1px solid var(--rx-border);
  border-radius: 6px;
  color: #60a5fa;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-use-now:hover {
  background: var(--rx-surface);
  border-color: #60a5fa;
}

.btn-use-now:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Timeline Bar (zoom + hover + arrastre) ── */
.timeline-interactive {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 14px;
}

.timeline-toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.timeline-range-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  min-width: 3.5rem;
  margin-right: 4px;
}

.timeline-tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  padding: 0;
  border: 1px solid #374151;
  border-radius: 6px;
  background: #1f2937;
  color: #e5e7eb;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.timeline-tool-btn:hover:not(:disabled) {
  background: #374151;
  border-color: #6b7280;
}

.timeline-tool-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.timeline-bar {
  position: relative;
  height: 32px;
  background: var(--rx-slot);
  border: 1px solid var(--rx-border);
  border-radius: 6px;
  cursor: crosshair;
  overflow: visible;
  touch-action: none;
}

.timeline-hover-tooltip {
  position: absolute;
  bottom: calc(100% + 6px);
  transform: translateX(-50%);
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(17, 24, 39, 0.95);
  border: 1px solid #374151;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: #f9fafb;
  white-space: nowrap;
  pointer-events: none;
  z-index: 20;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}

.timeline-indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--rx-accent);
  z-index: 10;
  pointer-events: none;
  box-shadow: 0 0 6px rgba(220, 38, 38, 0.6);
}

.timeline-hours {
  display: flex;
  position: absolute;
  inset: 0;
  align-items: center;
}

.timeline-hours--zoomed {
  display: block;
}

.hour-mark {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.hour-mark::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 8px;
  background: #374151;
}

.hour-mark:first-child::before {
  display: none;
}

.hour-mark span {
  font-size: 10px;
  color: #6b7280;
  margin-top: 10px;
}

.hour-mark--tick {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 0;
  flex: none;
  transform: translateX(-50%);
}

.hour-mark--tick::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 8px;
  background: #4b5563;
}

.hour-mark--tick span {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 9px;
  color: #9ca3af;
  margin-top: 0;
  white-space: nowrap;
}

.timeline-segments {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  height: 8px;
  pointer-events: none;
}

.segment {
  position: absolute;
  height: 100%;
  border-radius: 2px;
  opacity: 0.8;
}

.segment.continuous {
  background: #3b82f6;
}

.segment.event {
  background: #fbbf24;
}

.segment.manual {
  background: #a78bfa;
}

/* Zona restringida en la línea de tiempo */
.timeline-restricted-zone {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: repeating-linear-gradient(
    -45deg,
    rgba(220, 38, 38, 0.18),
    rgba(220, 38, 38, 0.18) 4px,
    rgba(220, 38, 38, 0.08) 4px,
    rgba(220, 38, 38, 0.08) 8px
  );
  border-right: 2px solid rgba(220, 38, 38, 0.55);
  z-index: 5;
  pointer-events: none;
  border-radius: 6px 0 0 6px;
}

/* ── Responsive ── */
@media (max-width: 1200px) {
  .recordings-header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .header-left {
    width: 100%;
    order: 1;
  }

  .header-center {
    order: 2;
  }

  .header-right {
    order: 3;
  }

  .header-left-vista {
    order: 1;
  }
}

@media (max-width: 768px) {
  .recordings-page {
    min-height: 0;
  }

  .view-label {
    display: none;
  }

  .grid-btn {
    width: 34px;
    height: 34px;
  }

  /* Una columna: varias filas 1fr para repartir alto entre slots */
  .video-grid.grid-1x2 {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(2, minmax(0, 1fr));
    height: 100%;
  }

  .video-grid.grid-2x2 {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(4, minmax(0, 1fr));
    height: 100%;
  }

  .video-slot {
    max-height: none;
  }

  .playback-controls {
    flex-wrap: wrap;
    gap: 8px;
  }

  .controls-left { order: 1; }
  .controls-center { order: 3; flex-basis: 100%; justify-content: center; }
  .controls-right { order: 2; margin-left: auto; }
}

@media (max-width: 480px) {
  .grid-controls {
    display: none;
  }

  .time-display {
    padding: 4px 8px;
    font-size: 11px;
  }

  .control-btn {
    width: 32px;
    height: 32px;
  }

  .control-btn.play-btn {
    width: 40px;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RecordingsPage.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,8FAA8F;EAC9F,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,4GAA4G;AAC5G;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,0EAA0E;EAC1E,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,2BAA2B;EAC3B,gCAAgC;AAClC;AACA,kCAAkC,wBAAwB,EAAE;AAC5D,uCAAuC,2BAA2B,EAAE;;AAEpE;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;AACA,0EAA0E,oBAAoB,EAAE;AAChG,2GAA2G;AAC3G,8DAA8D,oBAAoB,EAAE;;AAEpF;EACE,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;AACA,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1E,gCAAgC,cAAc,EAAE,cAAc,EAAE;AAChE,gCAAgC,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAChF,iCAAiC,kBAAkB,EAAE,gBAAgB,EAAE;AACvE;EACE,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,2BAA2B;EACrE,cAAc,EAAE,oBAAoB;AACtC;AACA;EACE,WAAW,EAAE,sBAAsB,EAAE,0BAA0B;EAC/D,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB;EAClE,cAAc,EAAE,eAAe,EAAE,aAAa;EAC9C,0DAA0D;AAC5D;AACA,yCAAyC,cAAc,EAAE;AACzD,kCAAkC,qBAAqB,EAAE,mBAAmB,EAAE;;AAE9E;EACE,SAAO,EAAE,aAAa,EAAE,cAAc,EAAE,aAAa,EAAE,uBAAuB;AAChF;AACA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wDAAwD;EACxD,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,8FAA8F;EAC9F,QAAQ;AACV;AACA,iCAAiC,YAAY,EAAE;AAC/C;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,WAAW;AACb;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,WAAW;EAC/E,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,aAAa,EAAE,gBAAgB;EAC9F,iCAAiC;AACnC;AACA;EACE,oCAAoC,EAAE,yCAAyC;AACjF;AACA;EACE,oCAAoC,EAAE,yCAAyC;AACjF;AACA;EACE,oCAAoC,EAAE,yCAAyC;AACjF;AACA;EACE,oCAAoC,EAAE,0CAA0C;AAClF;AACA,0CAA0C,uBAAuB,EAAE;AACnE,iCAAiC,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAChG,iEAAiE,8BAA8B,EAAE;AACjG,qEAAqE,kCAAkC,EAAE;AACzG,+DAA+D,4BAA4B,EAAE;AAC7F,oEAAoE,iCAAiC,EAAE;AACvG,kCAAkC,gBAAgB,EAAE,eAAe,EAAE,SAAO,EAAE;AAC9E;EACE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB;EACxE,WAAW,EAAE,eAAe,EAAE,kBAAkB;AAClD;AACA,mEAAmE,8BAA8B,EAAE;AACnG,uEAAuE,kCAAkC,EAAE;AAC3G,iEAAiE,4BAA4B,EAAE;AAC/F,sEAAsE,iCAAiC,EAAE;AACzG,qCAAqC,eAAe,EAAE,iBAAiB,EAAE;AACzE,6BAA6B,gCAAgC,EAAE,cAAc,EAAE,cAAc,EAAE;AAC/F,kCAAkC,yBAAyB,EAAE;AAC7D,0BAA0B,cAAc,EAAE,cAAc,EAAE,YAAY,EAAE;AACxE,0BAA0B,kBAAkB,EAAE;AAC9C;EACE,WAAW,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,cAAc;EAC3E,kBAAkB,EAAE,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EACnF,eAAe,EAAE,aAAa,EAAE,gBAAgB,EAAE,gDAAgD;EAClG,8BAA8B;AAChC;AACA,yCAAyC,0BAA0B,EAAE;AACrE,0CAA0C,0BAA0B,EAAE;AACtE,0CAA0C,0BAA0B,EAAE;AACtE,0CAA0C,0BAA0B,EAAE;AACtE;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC,EAAE,oCAAoC;AAChF;AACA,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;AACnF;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC,EAAE,oCAAoC;AAChF;AACA,+CAA+C,0BAA0B,EAAE;AAC3E,gDAAgD,0BAA0B,EAAE;AAC5E,gDAAgD,0BAA0B,EAAE;AAC5E,gDAAgD,0BAA0B,EAAE;AAC5E,2CAA2C,YAAY,EAAE;AACzD,kDAAkD,gBAAgB,EAAE;AACpE;EACE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,SAAO,EAAE,YAAY;AAC1H;AACA,+DAA+D,yBAAyB,EAAE;AAC1F,mEAAmE,6BAA6B,EAAE;AAClG,6DAA6D,uBAAuB,EAAE;AACtF,kEAAkE,4BAA4B,EAAE;AAChG,oCAAoC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvF,oEAAoE,yBAAyB,EAAE;AAC/F,wEAAwE,6BAA6B,EAAE;AACvG,kEAAkE,uBAAuB,EAAE;AAC3F,uEAAuE,4BAA4B,EAAE;AACrG,oCAAoC,cAAc,EAAE,gBAAgB,EAAE;AACtE,6BAA6B,eAAe,EAAE,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClH;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,kBAAkB;EACpF,mBAAmB,EAAE,yBAAyB,EAAE,YAAY,EAAE,gDAAgD;AAChH;AACA,kCAAkC,qBAAqB,EAAE,mBAAmB,EAAE;AAC9E,mCAAmC,gBAAgB,EAAE;AACrD;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc;EAC3D,yCAAyC;AAC3C;AACA,uCAAuC,mBAAmB,EAAE;AAC5D,wCAAwC,mBAAmB,EAAE;AAC7D,0CAA0C,mBAAmB,EAAE;AAC/D,4CAA4C,mBAAmB,EAAE;AACjE,iCAAiC,aAAa,EAAE;AAChD,gEAAgE,cAAc,EAAE;AAChF,kEAAkE,cAAc,EAAE;AAClF,iCAAiC,cAAc,EAAE,cAAc,EAAE;AACjE,iCAAiC,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzG,iCAAiC,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACjJ,oCAAoC,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACrI,kCAAkC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE,WAAW,EAAE;AACxI,kEAAkE,8BAA8B,EAAE;AAClG,sEAAsE,kCAAkC,EAAE;AAC1G,gEAAgE,4BAA4B,EAAE;AAC9F,qEAAqE,iCAAiC,EAAE;AACxG,2BAA2B,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC/E,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,kCAAkC,EAAE;AAChL,gCAAgC,cAAc,EAAE,kBAAkB,EAAE;;AAEpE;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,oDAAoD;AACrE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oFAAoF;EACpF,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oFAAoF;EACpF,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,oFAAoF;EACpF,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mFAAmF;EACnF,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yEAAyE;EACzE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;wGAIwG;AACxG;EACE,SAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yFAAyF;EACzF,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb;0FACwF;EACxF,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,oFAAoF;AACpF;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,SAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oFAAoF;EACpF,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sEAAsE;AACxE;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,uEAAuE;EACvE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;;;EAIE;AACF;EACE,aAAa;AACf;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,uFAAuF;EACvF,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;EAC/E,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA,0FAA0F;AAC1F;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,SAAS;AACX;;AAEA,6CAA6C;;AAQ7C;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,oFAAoF;EACpF,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;;EAEE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT;;;;;;GAMC;EACD,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iEAAiE;EACjE;IACE,qCAAqC;IACrC,6CAA6C;IAC7C,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,6CAA6C;IAC7C,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA,iBAAiB,QAAQ,EAAE;EAC3B,mBAAmB,QAAQ,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;EACxE,kBAAkB,QAAQ,EAAE,iBAAiB,EAAE;AACjD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ===== RECORDINGS PAGE – Figma-aligned dark theme ===== */\n\n.recordings-page {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  color: #fff;\n  overflow: hidden;\n  position: relative;\n  /* Paleta XTAM (Analytics / Inventario): fondos #0a0a0a–#111, bordes #374151, acento #a61b34 */\n  --rx-toolbar: #0a0a0a;\n  --rx-surface: #111111;\n  --rx-surface-2: #1a1a1a;\n  --rx-slot: #0a0a0a;\n  --rx-border: #374151;\n  --rx-accent: #a61b34;\n  --rx-accent-deep: #8b1528;\n}\n\n.recordings-page.loading-state {\n  align-items: center;\n  justify-content: center;\n}\n\n.recordings-page.loading-state .xtam-spinner--inline {\n  min-height: min(320px, 60vh);\n  padding: 40px 20px;\n}\n\n/* Misma lógica que .streams-shell: con el listado de cámaras abierto, la grilla no queda debajo del panel */\n.recordings-shell {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  overflow: hidden;\n  background: #000;\n  transition: width 0.25s ease;\n  box-sizing: border-box;\n}\n\n.recordings-shell.schema-sidebar-open {\n  width: calc(100% - 320px);\n  max-width: 100%;\n}\n\n/* ── Header / Toolbar ── */\n.recordings-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: var(--rx-toolbar);\n  border-bottom: 1px solid #1f2937;\n  gap: 8px;\n  min-height: 49px;\n  flex-shrink: 0;\n  z-index: 40;\n}\n\n.recordings-header-right {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.recordings-spoa-header-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.recordings-spoa-header-btn:hover:not(:disabled) {\n  border-color: #a61b34;\n  background: rgba(166, 27, 52, 0.15);\n}\n\n.recordings-spoa-header-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.recordings-spoa-header-badge {\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 999px;\n  background: #a61b34;\n  color: #fff;\n}\n\n.grid-controls .grid-clear-grid-btn {\n  margin-left: 6px;\n}\n\n.grid-btn:disabled,\n.grid-btn:disabled:hover {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: var(--rx-surface);\n  border-color: var(--rx-border);\n  color: #9ca3af;\n}\n\n/* ── Panel colapsable \"Cámaras disponibles\" (estilo /streams) ── */\n.recordings-schema-sidebar {\n  --schema-width: 320px;\n  --schema-pvvc: #3b82f6;\n  --schema-privados: #f97316;\n  --schema-eu: #E07054;\n  --schema-masivos: #14b8a6;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: var(--schema-width);\n  min-width: 0;\n  min-height: 0;\n  background: linear-gradient(195deg, #1c1c1c 0%, #121212 45%, #0e0e0e 100%);\n  border-left: 1px solid #333333;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  z-index: 10000;\n  transform: translateX(100%);\n  transition: transform 0.25s ease;\n}\n.recordings-schema-sidebar.open { transform: translateX(0); }\n.recordings-schema-sidebar.collapsed { transform: translateX(100%); }\n\n.recordings-schema-backdrop {\n  position: fixed;\n  inset: 0;\n  background: transparent;\n  z-index: 9999;\n  pointer-events: none;\n}\n.recordings-schema-backdrop.recordings-schema-backdrop-drag-passthrough { pointer-events: none; }\n/* Permitir drop sobre la grilla aunque el backdrop esté encima: se aplica en el mismo tick que dragStart */\nbody[data-dragging-from-schema] .recordings-schema-backdrop { pointer-events: none; }\n\n.recordings-schema-header {\n  padding: 14px 12px 12px;\n  border-bottom: 1px solid #333333;\n  background: #0e0e0e;\n}\n.recordings-schema-title { display: flex; align-items: center; gap: 10px; }\n.recordings-schema-title-icon { color: #9ca3af; flex-shrink: 0; }\n.recordings-schema-title-text { font-size: 15px; font-weight: 700; color: #fff; }\n.recordings-schema-search-wrap { position: relative; margin-top: 10px; }\n.recordings-schema-search-icon {\n  position: absolute; left: 10px; top: 50%; transform: translateY(-50%);\n  color: #6b7280; pointer-events: none;\n}\n.recordings-schema-search {\n  width: 100%; box-sizing: border-box; padding: 9px 12px 9px 34px;\n  border: 1px solid #3d3d3d; border-radius: 8px; background: #1a1a1a;\n  color: #e5e7eb; font-size: 13px; outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.recordings-schema-search::placeholder { color: #6b7280; }\n.recordings-schema-search:focus { border-color: #a61b34; background: #252525; }\n\n.recordings-schema-body {\n  flex: 1; min-height: 0; overflow: auto; padding: 10px; background: transparent;\n}\n.recordings-schema-toggle {\n  position: fixed;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 28px;\n  height: 56px;\n  border-radius: 10px 0 0 10px;\n  /* Portal a body: no hereda --rx-* de .recordings-page */\n  border: 4px solid #a61b34;\n  border-right: none;\n  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);\n  color: #fecaca;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10001;\n  transition: right 0.25s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  right: 0;\n}\n.recordings-schema-toggle.open { right: 320px; }\n.recordings-schema-toggle:hover {\n  background: linear-gradient(135deg, #c42a45 0%, #a61b34 100%);\n  border-color: #c42a45;\n  color: #fff;\n}\n\n.recordings-schema-section { margin-bottom: 14px; }\n.recordings-schema-section-header {\n  width: 100%; border: none; border-radius: 10px; padding: 10px 12px; color: #fff;\n  display: flex; align-items: center; gap: 8px; cursor: pointer; font: inherit; text-align: left;\n  transition: background 0.15s ease;\n}\n.recordings-schema-section-pvvc .recordings-schema-section-header {\n  background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.3);\n}\n.recordings-schema-section-privados .recordings-schema-section-header {\n  background: rgba(249, 115, 22, 0.15); border: 1px solid rgba(249, 115, 22, 0.3);\n}\n.recordings-schema-section-eu .recordings-schema-section-header {\n  background: rgba(224, 112, 84, 0.15); border: 1px solid rgba(224, 112, 84, 0.3);\n}\n.recordings-schema-section-masivos .recordings-schema-section-header {\n  background: rgba(20, 184, 166, 0.15); border: 1px solid rgba(20, 184, 166, 0.35);\n}\n.recordings-schema-section-header:hover { filter: brightness(1.1); }\n.recordings-schema-section-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }\n.recordings-schema-section-pvvc .recordings-schema-section-dot { background: var(--schema-pvvc); }\n.recordings-schema-section-privados .recordings-schema-section-dot { background: var(--schema-privados); }\n.recordings-schema-section-eu .recordings-schema-section-dot { background: var(--schema-eu); }\n.recordings-schema-section-masivos .recordings-schema-section-dot { background: var(--schema-masivos); }\n.recordings-schema-section-name { font-weight: 700; font-size: 13px; flex: 1; }\n.recordings-schema-section-count {\n  font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: 6px;\n  color: #fff; min-width: 28px; text-align: center;\n}\n.recordings-schema-section-pvvc .recordings-schema-section-count { background: var(--schema-pvvc); }\n.recordings-schema-section-privados .recordings-schema-section-count { background: var(--schema-privados); }\n.recordings-schema-section-eu .recordings-schema-section-count { background: var(--schema-eu); }\n.recordings-schema-section-masivos .recordings-schema-section-count { background: var(--schema-masivos); }\n.recordings-schema-section-content { margin-top: 8px; padding-left: 4px; }\n.recordings-schema-chevron { transition: transform 0.15s ease; color: #9ca3af; flex-shrink: 0; }\n.recordings-schema-chevron.open { transform: rotate(180deg); }\n.recordings-schema-grip { color: #6b7280; flex-shrink: 0; cursor: grab; }\n.recordings-schema-site { margin-bottom: 6px; }\n.recordings-schema-site-header {\n  width: 100%; background: #1a1a1a; border: 1px solid #3d3d3d; color: #e5e7eb;\n  border-radius: 8px; padding: 8px 10px; display: flex; align-items: center; gap: 8px;\n  cursor: pointer; font: inherit; text-align: left; transition: border-color 0.15s, background 0.15s;\n  border-left: 3px solid #6b7280;\n}\n.recordings-schema-site-header--online { border-left-color: #10B981; }\n.recordings-schema-site-header--partial { border-left-color: #F59E0B; }\n.recordings-schema-site-header--offline { border-left-color: #EF4444; }\n.recordings-schema-site-header--unknown { border-left-color: #6b7280; }\n.recordings-schema-section-pvvc .recordings-schema-site-header {\n  background: rgba(59, 130, 246, 0.06);\n}\n.recordings-schema-section-privados .recordings-schema-site-header {\n  background: rgba(249, 115, 22, 0.06);\n}\n.recordings-schema-section-eu .recordings-schema-site-header {\n  background: rgba(224, 112, 84, 0.06);\n}\n.recordings-schema-section-masivos .recordings-schema-site-header {\n  border-left-color: var(--schema-masivos); background: rgba(20, 184, 166, 0.06);\n}\n.recordings-schema-site-header:hover { background: #252525; border-color: #4b5563; }\n.recordings-schema-section-pvvc .recordings-schema-site-header:hover {\n  background: rgba(59, 130, 246, 0.12);\n}\n.recordings-schema-section-privados .recordings-schema-site-header:hover {\n  background: rgba(249, 115, 22, 0.12);\n}\n.recordings-schema-section-eu .recordings-schema-site-header:hover {\n  background: rgba(224, 112, 84, 0.12);\n}\n.recordings-schema-section-masivos .recordings-schema-site-header:hover {\n  border-left-color: var(--schema-masivos); background: rgba(20, 184, 166, 0.12);\n}\n.recordings-schema-site-header--online:hover { border-left-color: #10B981; }\n.recordings-schema-site-header--partial:hover { border-left-color: #F59E0B; }\n.recordings-schema-site-header--offline:hover { border-left-color: #EF4444; }\n.recordings-schema-site-header--unknown:hover { border-left-color: #6b7280; }\n.recordings-schema-site-header-draggable { cursor: grab; }\n.recordings-schema-site-header-draggable:active { cursor: grabbing; }\n.recordings-schema-site-name {\n  font-size: 12px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; min-width: 0;\n}\n.recordings-schema-section-pvvc .recordings-schema-site-name { color: var(--schema-pvvc); }\n.recordings-schema-section-privados .recordings-schema-site-name { color: var(--schema-privados); }\n.recordings-schema-section-eu .recordings-schema-site-name { color: var(--schema-eu); }\n.recordings-schema-section-masivos .recordings-schema-site-name { color: var(--schema-masivos); }\n.recordings-schema-site-cam-count { font-size: 11px; font-weight: 600; flex-shrink: 0; }\n.recordings-schema-section-pvvc .recordings-schema-site-cam-count { color: var(--schema-pvvc); }\n.recordings-schema-section-privados .recordings-schema-site-cam-count { color: var(--schema-privados); }\n.recordings-schema-section-eu .recordings-schema-site-cam-count { color: var(--schema-eu); }\n.recordings-schema-section-masivos .recordings-schema-site-cam-count { color: var(--schema-masivos); }\n.recordings-schema-site-cam-total { color: #6b7280; font-weight: 400; }\n.recordings-schema-cameras { margin-top: 6px; padding-left: 8px; display: flex; flex-direction: column; gap: 4px; }\n.recordings-schema-camera {\n  display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px;\n  background: #1a1a1a; border: 1px solid #3d3d3d; cursor: grab; transition: border-color 0.15s, background 0.15s;\n}\n.recordings-schema-camera:hover { border-color: #4b5563; background: #252525; }\n.recordings-schema-camera:active { cursor: grabbing; }\n.recordings-schema-camera-status {\n  width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.35);\n}\n.recordings-schema-camera-status--on { background: #22c55e; }\n.recordings-schema-camera-status--off { background: #dc2626; }\n.recordings-schema-camera-status--issue { background: #f97316; }\n.recordings-schema-camera-status--unknown { background: #6b7280; }\n.recordings-schema-camera--off { opacity: 0.72; }\n.recordings-schema-camera--off .recordings-schema-camera-name { color: #d1d5db; }\n.recordings-schema-camera--issue .recordings-schema-camera-name { color: #fdba74; }\n.recordings-schema-camera-warn { color: #f87171; flex-shrink: 0; }\n.recordings-schema-camera-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.recordings-schema-camera-name { font-size: 12px; font-weight: 600; color: #fff; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.recordings-schema-camera-address { font-size: 11px; color: #9ca3af; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.recordings-schema-camera-badge { font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 4px; flex-shrink: 0; color: #fff; }\n.recordings-schema-section-pvvc .recordings-schema-camera-badge { background: var(--schema-pvvc); }\n.recordings-schema-section-privados .recordings-schema-camera-badge { background: var(--schema-privados); }\n.recordings-schema-section-eu .recordings-schema-camera-badge { background: var(--schema-eu); }\n.recordings-schema-section-masivos .recordings-schema-camera-badge { background: var(--schema-masivos); }\n.recordings-schema-empty { color: #9ca3af; font-size: 12px; padding: 8px 10px; }\n.recordings-schema-hint { margin-top: 10px; font-size: 12px; color: #9ca3af; padding: 10px; border-radius: 8px; border: 1px dashed #3d3d3d; background: rgba(255,255,255,0.03); }\n.recordings-schema-no-results { color: #6b7280; font-style: italic; }\n\n.header-left {\n  flex: 0 0 280px;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 8px;\n  padding: 7px 12px;\n  gap: 8px;\n  transition: border-color 0.2s;\n}\n\n.search-box:hover {\n  border-color: #4b5563;\n}\n\n.search-box:focus-within {\n  border-color: var(--rx-accent);\n}\n\n.search-icon {\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.search-box input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 12px;\n  outline: none;\n}\n\n.search-box input::placeholder {\n  color: #6b7280;\n}\n\n.header-center {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.cameras-label {\n  display: none; /* hidden in Figma design */\n}\n\n/* PVVC / Privado toggle switch – matches search box width */\n.tabs {\n  display: flex;\n  flex: 0 0 280px;\n  box-sizing: border-box;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 4px;\n  overflow: hidden;\n  padding: 1px;\n}\n\n.tab {\n  flex: 1;\n  padding: 3px 14px;\n  background: transparent;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  white-space: nowrap;\n  line-height: 1.4;\n  text-align: center;\n}\n\n/* PVVC inactive = blue text */\n.tab:first-child {\n  color: #60a5fa;\n}\n\n.tab:first-child:hover:not(.active) {\n  background: rgba(59, 130, 246, 0.15);\n}\n\n/* PVVC active = solid blue bg */\n.tab:first-child.active {\n  background: #3b82f6;\n  color: #fff;\n}\n\n/* Privado inactive = orange text */\n.tab:last-child {\n  color: #fb923c;\n}\n\n.tab:last-child:hover:not(.active) {\n  background: rgba(249, 115, 22, 0.15);\n}\n\n/* Privado active = solid orange bg */\n.tab:last-child.active {\n  background: #f97316;\n  color: #fff;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.header-left-vista {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.btn-toggle-cameras {\n  display: none; /* panel is controlled by tab toggle in new design */\n}\n\n.view-label {\n  color: #9ca3af;\n  font-size: 14px;\n  margin-right: 4px;\n}\n\n.grid-controls {\n  display: flex;\n  gap: 4px;\n}\n\n.grid-btn {\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.grid-btn:hover {\n  background: var(--rx-surface);\n  color: #d1d5db;\n}\n\n.grid-btn.active {\n  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);\n  border-color: var(--rx-accent);\n  color: #fff;\n}\n\n.grid-btn.highlight.active {\n  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);\n  color: #fff;\n}\n\n.grid-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n/* ── Camera Cards Panel (horizontal accordion, in document flow) ── */\n.camera-cards-panel {\n  max-height: 135px;\n  background: rgba(0, 0, 0, 0.98);\n  backdrop-filter: blur(8px);\n  border-bottom: 2px solid #3b82f6;\n  overflow: hidden;\n  flex-shrink: 0;\n  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, border-color 0.3s;\n  opacity: 1;\n}\n\n.camera-cards-panel.panel-hidden {\n  max-height: 0;\n  opacity: 0;\n  pointer-events: none;\n  border-bottom-width: 0;\n}\n\n.camera-cards-panel.privado-panel {\n  border-bottom-color: #f97316;\n}\n\n.camera-cards-scroll {\n  display: grid;\n  grid-template-rows: repeat(2, 1fr);\n  grid-auto-flow: column;\n  grid-auto-columns: 252px;\n  gap: 10px;\n  padding: 6px 8px;\n  height: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.camera-cards-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.no-cameras-message {\n  color: #6b7280;\n  font-size: 13px;\n  padding: 20px;\n  text-align: center;\n  grid-column: 1 / -1;\n  grid-row: 1 / -1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Camera Card (in panel) */\n.camera-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, var(--rx-surface-2) 0%, var(--rx-surface) 100%);\n  border: 1px solid var(--rx-border);\n  border-radius: 8px;\n  cursor: grab;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  height: 100%;\n}\n\n.camera-card:hover {\n  background: linear-gradient(135deg, #252525 0%, var(--rx-surface-2) 100%);\n  border-color: #4b5563;\n}\n\n.camera-card:active {\n  cursor: grabbing;\n}\n\n.camera-card.dragging {\n  opacity: 0.5;\n  transform: scale(0.98);\n}\n\n.camera-card.in-use {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.camera-card.in-use:hover {\n  background: linear-gradient(135deg, var(--rx-surface-2) 0%, var(--rx-surface) 100%);\n}\n\n.card-drag-handle {\n  width: 14px;\n  height: 20px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.card-drag-handle svg {\n  width: 100%;\n  height: 100%;\n}\n\n.card-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.card-site-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-address {\n  font-size: 10px;\n  color: #9ca3af;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-camera-name {\n  font-size: 10px;\n  color: #d1d5db;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 1px;\n}\n\n.card-type-badge {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.card-type-badge.pvvc {\n  background: #3b82f6;\n  color: #fff;\n}\n\n.card-type-badge.privado {\n  background: #f97316;\n  color: #fff;\n}\n\n/* ── Video Grid ──\n   La grilla ocupa el flex restante bajo el header; 1×1 / 1×2 / 2×2 usan filas 1fr para que los slots\n   llenen el alto (el vídeo mantiene proporción con object-fit dentro del reproductor).\n   El contenedor es CSS Grid (1 fila 1fr), no flex-column: así el hijo .video-grid recibe altura de pista\n   definida y no colapsa la fila 1fr interna (evita una sola celda “en banda” con hueco negro debajo). */\n.video-grid-container {\n  flex: 1 1 0%;\n  min-height: 0;\n  max-height: 100%;\n  padding: 10px;\n  /* Sin scroll: el grid ajusta sus pistas a la altura disponible y los slots se achican. */\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  box-sizing: border-box;\n}\n\n.video-grid {\n  display: grid;\n  gap: 8px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 0;\n  max-height: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  align-self: stretch;\n  justify-self: stretch;\n}\n\n.video-grid.grid-1x1 {\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  justify-items: stretch;\n  align-content: stretch;\n}\n\n.video-grid.grid-1x2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: minmax(0, 1fr);\n  align-content: stretch;\n}\n\n.video-grid.grid-2x2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n  align-content: stretch;\n}\n\n/* ── Video Slot ── */\n.video-slot {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 0;\n  /* El alto viene de la pista del grid (1fr). Evitamos aspect-ratio / max-height fijos para que\n     al cambiar el tamaño del viewport los slots se encojan y quepan sin generar scroll. */\n  height: 100%;\n  align-self: stretch;\n  background: var(--rx-slot);\n  border: 2px dashed var(--rx-border);\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.2s;\n}\n\n.video-slot.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-slot.empty:hover,\n.video-slot.drop-target.empty {\n  border-color: var(--rx-accent);\n  background: rgba(166, 27, 52, 0.08);\n}\n\n.video-slot.has-camera {\n  border-style: solid;\n  border-color: transparent;\n  border-width: 0;\n  background: var(--rx-slot);\n}\n\n/* Un solo borde: el marco es el .video-slot; la drop zone anidada no repite borde */\n.video-slot .camera-drop-zone {\n  border: none;\n}\n\n.video-slot .recording-card.recording-card-slot {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* El relleno del slot (drop zone / video) debe ocupar toda la altura de la celda */\n.video-slot .recording-card.recording-card-slot > .camera-drop-zone {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n.video-slot-expanded-placeholder {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--rx-slot);\n  color: #6b7280;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.video-slot-expanded-placeholder:hover {\n  background: var(--rx-surface);\n  color: #d1d5db;\n}\n\n.video-slot-expanded-placeholder .placeholder-hint {\n  font-size: 11px;\n  color: #4b5563;\n}\n\n.empty-slot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #4b5563;\n  text-align: center;\n  padding: 20px;\n}\n\n.slot-icon {\n  width: 32px;\n  height: 32px;\n  color: #374151;\n}\n\n.slot-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.slot-text {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.slot-number {\n  font-size: 10px;\n  color: #4b5563;\n}\n\n/* ── Video Content (camera in slot) ── */\n.video-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: var(--rx-slot);\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.video-content .video-stream {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n}\n\n/* Camera info overlay at top center */\n.video-info-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  padding: 8px 12px;\n  z-index: 5;\n  pointer-events: none;\n}\n\n.camera-info-overlay {\n  background: rgba(0, 0, 0, 0.7);\n  padding: 4px 12px;\n  border-radius: 6px;\n  text-align: center;\n  max-width: 80%;\n}\n\n.overlay-site {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.overlay-name {\n  font-size: 10px;\n  color: #d1d5db;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Type badge at bottom-left */\n.overlay-badge {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  z-index: 5;\n}\n\n.overlay-badge.pvvc {\n  background: #3b82f6;\n  color: #fff;\n}\n\n.overlay-badge.privado {\n  background: #f97316;\n  color: #fff;\n}\n\n/* REC indicator at bottom-right */\n.rec-indicator {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);\n  padding: 6px;\n  border-radius: 4px;\n  z-index: 5;\n}\n\n.rec-indicator svg {\n  width: 18px;\n  height: 18px;\n  color: #fff;\n  fill: currentColor;\n  stroke: currentColor;\n}\n\n/* Drag handle at top-left */\n.slot-drag-handle {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: rgba(0, 0, 0, 0.7);\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: move;\n  z-index: 10;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.video-slot:hover .slot-drag-handle {\n  opacity: 1;\n}\n\n.slot-drag-handle svg {\n  width: 16px;\n  height: 16px;\n  color: #fff;\n}\n\n/* Expand button (center, on hover) */\n.expand-camera-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 44px;\n  height: 44px;\n  background: rgba(166, 27, 52, 0.92);\n  border: none;\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.expand-camera-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.video-slot:hover .expand-camera-btn {\n  opacity: 0.4;\n}\n\n.video-slot:hover .expand-camera-btn:hover {\n  opacity: 1;\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n/* Remove button (top-right, on hover) */\n.remove-camera-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);\n  border: none;\n  border-radius: 4px;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.video-slot:hover .remove-camera-btn {\n  opacity: 1;\n}\n\n.remove-camera-btn:hover {\n  background: linear-gradient(135deg, #c42a45 0%, var(--rx-accent) 100%);\n}\n\n/* ── Modal video ampliado ── */\n.video-expand-overlay {\n  position: fixed;\n  inset: 0;\n  /* Por encima del sidebar (1000) para que el modal no quede recortado */\n  z-index: 1100;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: fadeIn 0.3s ease;\n}\n\n/*\n * Modal SIEMPRE montado para que `expandedPlayerHost` (destino del portal del `<video>`) sea estable:\n * teletransportar el `<video>` entre grid y modal sin desmontarlo es lo que preserva el buffer Hls.js\n * (segmentos m3u8/ts). Cuando no hay slot maximizado, se oculta el contenedor entero.\n */\n.video-expand-overlay--hidden {\n  display: none;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.video-expand-content {\n  position: relative;\n  width: 100%;\n  max-width: 95vw;\n  max-height: 90vh;\n  background: var(--rx-surface);\n  border: 1px solid var(--rx-border);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.video-expand-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  background: rgba(166, 27, 52, 0.92);\n  border: none;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.video-expand-content:hover .video-expand-close {\n  opacity: 0.4;\n}\n\n.video-expand-close:hover {\n  opacity: 1 !important;\n}\n\n.video-expand-evidence {\n  position: absolute;\n  top: 12px;\n  right: 56px;\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.video-expand-content:hover .video-expand-evidence {\n  opacity: 0.55;\n}\n\n.video-expand-evidence:hover {\n  opacity: 1 !important;\n  border-color: #a61b34;\n  background: rgba(166, 27, 52, 0.35);\n}\n\n.video-expand-evidence--captured {\n  opacity: 1 !important;\n  border-color: #22c55e !important;\n  background: rgba(34, 197, 94, 0.4) !important;\n  animation: rx-expand-evidence-pop 0.55s ease;\n}\n\n@keyframes rx-expand-evidence-pop {\n  0% {\n    transform: scale(1);\n  }\n  35% {\n    transform: scale(1.08);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.video-expand-player {\n  position: relative;\n  width: 100%;\n  flex: 0 1 auto;\n  min-height: 0;\n  aspect-ratio: 16 / 9;\n  /* Deja espacio para título + barra de reproducción (timeline, play/stop, fecha/hora) */\n  max-height: min(56vw, calc(95vh - 280px));\n  background: #000;\n}\n\n.video-expand-player .video-stream {\n  width: 100%;\n  height: 100%;\n}\n\n.video-expand-player .video-stream video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.video-expand-loading,\n.video-expand-error {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 24px;\n  background: #0a0a0a;\n  color: var(--rx-text, #e8e8e8);\n}\n\n.video-expand-error-text {\n  margin: 0;\n  text-align: center;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  max-width: 360px;\n}\n\n.video-expand-retry {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #a61b34 0%, var(--rx-accent, #c42a45) 100%);\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.video-expand-retry:hover {\n  filter: brightness(1.08);\n}\n\n.video-expand-overlay-bottom {\n  position: absolute;\n  bottom: 14px;\n  left: 34px;\n  right: auto;\n  width: max-content;\n  max-width: calc(100% - 48px);\n  z-index: 10;\n  padding: 10px 14px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  pointer-events: none;\n}\n\n.video-expand-status-pill,\n.video-expand-time-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: rgba(0, 0, 0, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n\n.video-expand-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #9ca3af;\n}\n\n.video-expand-status-pill.playing .video-expand-status-dot {\n  background: #22c55e;\n}\n\n.video-expand-status-pill.loading .video-expand-status-dot {\n  background: #f59e0b;\n}\n\n.video-expand-status-pill.error .video-expand-status-dot,\n.video-expand-status-pill.offline .video-expand-status-dot {\n  background: #ef4444;\n}\n\n.video-expand-info {\n  flex-shrink: 0;\n  padding: 10px 16px;\n  background: var(--rx-toolbar);\n  border-top: 1px solid var(--rx-border);\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* Controles de reproducción dentro del modal ampliado (misma barra que en vista normal) */\n.video-expand-playback.playback-section {\n  flex-shrink: 0;\n  max-height: min(50vh, 420px);\n  overflow-y: auto;\n}\n\n/* En pantallas estrechas, permitir que los controles envuelvan sin cortarse */\n.video-expand-playback .playback-controls {\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n/* ── Fullscreen nativo (Fullscreen API) ── */\n\n.video-expand-overlay:fullscreen,\n.video-expand-overlay:-webkit-full-screen {\n  background: #000;\n  padding: 0;\n}\n\n.video-expand-overlay:fullscreen::backdrop,\n.video-expand-overlay:-webkit-full-screen::backdrop {\n  background: #000;\n}\n\n.video-expand-overlay--fullscreen {\n  background: #000;\n  padding: 0;\n}\n\n.video-expand-overlay--fullscreen .video-expand-content {\n  max-width: 100%;\n  max-height: 100%;\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  background: #000;\n}\n\n.video-expand-overlay--fullscreen .video-expand-player {\n  flex: 1 1 auto;\n  max-height: none;\n  aspect-ratio: auto;\n}\n\n.video-expand-overlay--fullscreen .video-expand-player .video-stream video {\n  object-fit: contain;\n}\n\n.video-expand-overlay--fullscreen .video-expand-info {\n  background: rgba(0, 0, 0, 0.85);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.video-expand-overlay--fullscreen .video-expand-playback.playback-section {\n  background: rgba(0, 0, 0, 0.9);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  max-height: none;\n}\n\n.video-expand-overlay--fullscreen .playback-controls {\n  background: transparent;\n}\n\n.video-expand-overlay--fullscreen .video-expand-close {\n  top: 16px;\n  right: 16px;\n  width: 44px;\n  height: 44px;\n  font-size: 24px;\n}\n\n/* ── Playback Section ── */\n.playback-section {\n  background: var(--rx-toolbar);\n  border-top: 1px solid #1f2937;\n  flex-shrink: 0;\n  padding: 12px;\n}\n\n.playback-section .playback-inner {\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.playback-error-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: rgba(166, 27, 52, 0.15);\n  border: 1px solid var(--rx-accent);\n  border-radius: 8px;\n  color: #fca5a5;\n  font-size: 13px;\n}\n\n.playback-error-banner button {\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0 6px;\n}\n\n.recording-extend-banner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px 16px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  background: rgba(234, 179, 8, 0.12);\n  border: 1px solid rgba(234, 179, 8, 0.45);\n  border-radius: 8px;\n  color: #fde68a;\n  font-size: 13px;\n}\n\n.recording-extend-banner__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.recording-extend-banner .btn-extend-confirm {\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  background: #ca8a04;\n  color: #0a0a0a;\n}\n\n.recording-extend-banner .btn-extend-dismiss {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: transparent;\n  color: #e5e7eb;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.playback-loading-banner {\n  padding: 8px 12px;\n  background: rgba(59, 130, 246, 0.15);\n  border: 1px solid #3b82f6;\n  border-radius: 8px;\n  color: #93c5fd;\n  font-size: 13px;\n}\n\n/* Playback Controls */\n.playback-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.controls-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.control-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--rx-surface);\n  border: 1px solid var(--rx-border);\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.control-btn:hover {\n  background: var(--rx-surface-2);\n  border-color: #4b5563;\n}\n\n.control-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.control-btn.play-btn {\n  width: 44px;\n  height: 44px;\n  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);\n  border: none;\n  border-radius: 50%;\n}\n\n.control-btn.play-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c42a45 0%, var(--rx-accent) 100%);\n}\n\n.control-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.time-display {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 6px;\n  color: #fff;\n  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;\n  font-size: 13px;\n}\n\n.clock-icon {\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n}\n\n.controls-center {\n  display: flex;\n  align-items: center;\n}\n\n.speed-controls {\n  display: flex;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.speed-btn {\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.speed-btn:hover {\n  color: #fff;\n  background: var(--rx-surface);\n}\n\n.speed-btn.active {\n  background: linear-gradient(135deg, var(--rx-accent) 0%, var(--rx-accent-deep) 100%);\n  color: #fff;\n}\n\n.controls-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.date-picker,\n.time-picker {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 6px;\n  position: relative;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.date-picker.date-picker--loading,\n.time-picker.time-picker--loading {\n  border-color: var(--rx-accent);\n  box-shadow: 0 0 0 1px rgba(166, 27, 52, 0.35);\n}\n\n.date-picker-loader {\n  color: var(--rx-accent);\n  flex-shrink: 0;\n  animation: rspoa-spin 0.9s linear infinite;\n}\n\n@keyframes rspoa-spin {\n  to { transform: rotate(360deg); }\n}\n\n.calendar-icon {\n  width: 18px;\n  height: 18px;\n  color: #6b7280;\n}\n\n.date-picker input,\n.time-picker input.time-picker-native {\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  outline: none;\n  cursor: pointer;\n  font-variant-numeric: tabular-nums;\n  color-scheme: dark;\n  min-width: 5.5rem;\n}\n\n.date-picker input:disabled,\n.time-picker input.time-picker-native:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.date-picker input::-webkit-calendar-picker-indicator,\n.time-picker input.time-picker-native::-webkit-calendar-picker-indicator {\n  filter: invert(0.7);\n  cursor: pointer;\n  opacity: 1;\n}\n\n.btn-use-now {\n  padding: 6px 12px;\n  background: var(--rx-toolbar);\n  border: 1px solid var(--rx-border);\n  border-radius: 6px;\n  color: #60a5fa;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-use-now:hover {\n  background: var(--rx-surface);\n  border-color: #60a5fa;\n}\n\n.btn-use-now:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Timeline Bar (zoom + hover + arrastre) ── */\n.timeline-interactive {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 0 14px;\n}\n\n.timeline-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.timeline-range-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  min-width: 3.5rem;\n  margin-right: 4px;\n}\n\n.timeline-tool-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  background: #1f2937;\n  color: #e5e7eb;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.timeline-tool-btn:hover:not(:disabled) {\n  background: #374151;\n  border-color: #6b7280;\n}\n\n.timeline-tool-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.timeline-bar {\n  position: relative;\n  height: 32px;\n  background: var(--rx-slot);\n  border: 1px solid var(--rx-border);\n  border-radius: 6px;\n  cursor: crosshair;\n  overflow: visible;\n  touch-action: none;\n}\n\n.timeline-hover-tooltip {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  transform: translateX(-50%);\n  padding: 4px 8px;\n  border-radius: 4px;\n  background: rgba(17, 24, 39, 0.95);\n  border: 1px solid #374151;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: #f9fafb;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 20;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);\n}\n\n.timeline-indicator {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: var(--rx-accent);\n  z-index: 10;\n  pointer-events: none;\n  box-shadow: 0 0 6px rgba(220, 38, 38, 0.6);\n}\n\n.timeline-hours {\n  display: flex;\n  position: absolute;\n  inset: 0;\n  align-items: center;\n}\n\n.timeline-hours--zoomed {\n  display: block;\n}\n\n.hour-mark {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.hour-mark::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1px;\n  height: 8px;\n  background: #374151;\n}\n\n.hour-mark:first-child::before {\n  display: none;\n}\n\n.hour-mark span {\n  font-size: 10px;\n  color: #6b7280;\n  margin-top: 10px;\n}\n\n.hour-mark--tick {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 0;\n  flex: none;\n  transform: translateX(-50%);\n}\n\n.hour-mark--tick::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 1px;\n  height: 8px;\n  background: #4b5563;\n}\n\n.hour-mark--tick span {\n  position: absolute;\n  top: 11px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 9px;\n  color: #9ca3af;\n  margin-top: 0;\n  white-space: nowrap;\n}\n\n.timeline-segments {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  right: 0;\n  height: 8px;\n  pointer-events: none;\n}\n\n.segment {\n  position: absolute;\n  height: 100%;\n  border-radius: 2px;\n  opacity: 0.8;\n}\n\n.segment.continuous {\n  background: #3b82f6;\n}\n\n.segment.event {\n  background: #fbbf24;\n}\n\n.segment.manual {\n  background: #a78bfa;\n}\n\n/* Zona restringida en la línea de tiempo */\n.timeline-restricted-zone {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: repeating-linear-gradient(\n    -45deg,\n    rgba(220, 38, 38, 0.18),\n    rgba(220, 38, 38, 0.18) 4px,\n    rgba(220, 38, 38, 0.08) 4px,\n    rgba(220, 38, 38, 0.08) 8px\n  );\n  border-right: 2px solid rgba(220, 38, 38, 0.55);\n  z-index: 5;\n  pointer-events: none;\n  border-radius: 6px 0 0 6px;\n}\n\n/* ── Responsive ── */\n@media (max-width: 1200px) {\n  .recordings-header {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .header-left {\n    width: 100%;\n    order: 1;\n  }\n\n  .header-center {\n    order: 2;\n  }\n\n  .header-right {\n    order: 3;\n  }\n\n  .header-left-vista {\n    order: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .recordings-page {\n    min-height: 0;\n  }\n\n  .view-label {\n    display: none;\n  }\n\n  .grid-btn {\n    width: 34px;\n    height: 34px;\n  }\n\n  /* Una columna: varias filas 1fr para repartir alto entre slots */\n  .video-grid.grid-1x2 {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n    height: 100%;\n  }\n\n  .video-grid.grid-2x2 {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n    height: 100%;\n  }\n\n  .video-slot {\n    max-height: none;\n  }\n\n  .playback-controls {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .controls-left { order: 1; }\n  .controls-center { order: 3; flex-basis: 100%; justify-content: center; }\n  .controls-right { order: 2; margin-left: auto; }\n}\n\n@media (max-width: 480px) {\n  .grid-controls {\n    display: none;\n  }\n\n  .time-display {\n    padding: 4px 8px;\n    font-size: 11px;\n  }\n\n  .control-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .control-btn.play-btn {\n    width: 40px;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
